module.exports = __webpack_public_path__ + "static/media/info.51a3305b.svg";